import { createRouter, createWebHistory } from 'vue-router';
import { useContextStore } from '@/stores/context';
import homeView from '@/views/HomePageView.vue';
import NotFound from '@/views/NotFoundView.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import LoadingView from '@/views/LoadingView.vue';
import MaintanceView from '@/views/MaintanceView.vue';
import PrivacyPolicyView from '@/views/PrivacyPolicyView.vue';
import BudgetView from '@/views/BudgetView.vue';
import SpecialLayout from '@/layouts/SpecialLayout.vue';
import ThankYouView from '@/views/ThankYouView.vue';
import NotAllowedActionView from '@/views/NotAllowedActionView.vue';
import MainCtaView from '@/views/MainCtaView.vue';

const routes = [
    {
        path: "/",
        name: "public",
        component: DefaultLayout,
        redirect: "/",
        children: [
            {
                path: '',
                name: 'Home',
                component: homeView
            },
            {
                path: 'privacypolicy',
                name: 'PrivacyPolicy',
                component: PrivacyPolicyView
            },
            {
                path: 'budget',
                name: 'Budget',
                component: BudgetView
            },
            {
                path: 'thankYou',
                name: 'ThankYou',
                component: ThankYouView
            },
        ]
    },
    {
        path: "/",
        name: "special",
        component: SpecialLayout,
        redirect: "/",
        children: [
            {
                path: 'budget',
                name: 'Budget',
                component: BudgetView
            },
            {
                path: 'opportunity',
                name: 'Opportunity',
                component: MainCtaView
            }
        ]
    },
    {
        path: '/loading',
        name: 'Loading',
        component: LoadingView
    },
    {
        path: '/action_not_allowed',
        name: 'ActionNotAllowed',
        component: NotAllowedActionView
    },
    {
        path: '/maintance',
        name: 'Maintance',
        component: MaintanceView
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.path === from.path) {
            return false;
        }
        
        if (savedPosition) {
            return savedPosition;
        }
        
        return { top: 0 };
    }
});


/**
 * Middleware to check auth routes
 */
router.beforeEach((to, from, next) => {    
    if (['true', true].includes(process.env.VUE_APP_ON_MAINTANCE) && to.path != '/maintance') {
        return next('/maintance');
    }
    
    if (to.path !== from.path) {
        const context = useContextStore();
        context.setLoadingApplication(true);
    }
    
    next();
});

router.afterEach((to, from) => {
    if (to.path !== from.path) {
        const context = useContextStore();
        
        requestAnimationFrame(() => {
            setTimeout(() => {
                context.setLoadingApplication(false);
            }, 50);
        });
    }
});

export default router;
